import DLL from "./dll";

export default { DLL };
